import GATSBY_COMPILED_MDX from "/home/runner/work/techfar-hub-website-v3/techfar-hub-website-v3/tech-far-hub/content/pre-solicitation/the-agile-team.mdx";
import * as React from "react";
import SiteLayout from "../components/site-layout";
import MDXContent from "../components/mdxcontent";
import {SEO} from "../components/seo";
import PageLayoutNav from "../components/page-layout-nav";
const DefaultPageTemplate = _ref => {
  let {data, children, pageContext} = _ref;
  if (data.currentPage.frontmatter && data.siblings && data.currentPage.tableOfContents) {
    return React.createElement(PageLayoutNav, {
      frontmatter: data.currentPage.frontmatter,
      siblings: data.siblings,
      tableOfContents: data.currentPage.tableOfContents,
      pageContext: pageContext,
      useNextLink: false
    }, React.createElement(MDXContent, null, children));
  }
  return React.createElement(SiteLayout, {
    pagePath: pageContext.pagePath
  }, React.createElement("h1", null, "Something went wrong"));
};
DefaultPageTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DefaultPageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref2 => {
  var _data$currentPage;
  let {data} = _ref2;
  return React.createElement(SEO, {
    frontmatter: (_data$currentPage = data.currentPage) === null || _data$currentPage === void 0 ? void 0 : _data$currentPage.frontmatter
  });
};
const query = "2911962555";
